import { useState, useEffect } from 'react';
import { fetchGeolocation } from '../utils/apiService';

/**
 * Custom hook to fetch and store geolocation data
 */
export const useGeolocation = () => {
  const [geoData, setGeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getGeolocation = async () => {
      try {
        setLoading(true);
        const data = await fetchGeolocation();
        
        if (data && data.isSuccess) {
          setGeoData(data);
        } else {
          setError('Failed to fetch location');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getGeolocation();
  }, []);

  return { geoData, loading, error };
};
